export const EMPLOYEES = [
  {
    id: 101,
    prenom: "Alexandre",
    nom: "Morel",
    poste: "Responsable produit",
    equipe: "Origami Core",
    notes:
      "Anime les ateliers de cadrage en veillant à ce que tout le monde ait la parole, y compris les plus discrets. A co-piloté la formation interne sur les biais des IA conversationnelles."
  },
  {
    id: 118,
    prenom: "Samir",
    nom: "Haddad",
    poste: "Ingénieur fiabilité",
    equipe: "Infra & SRE",
    notes:
      "Parle à la machine à café comme à un collègue, et veille à ce que personne ne reste seul pendant les astreintes. Chien : Balthazar. A déjà appelé Balthazar « collègue » également."
  },
  {
    id: 132,
    prenom: "Clara",
    nom: "Nguyen",
    poste: "Data scientist",
    equipe: "Origami ML",
    notes:
      "Rappelle à chaque rétrospective que les jeux de données doivent rester représentatifs et non discriminants. A proposé de suivre un indicateur interne sur l’équité des modèles."
  },
  {
    id: 147,
    prenom: "Julien",
    nom: "Perez",
    poste: "Développeur backend",
    equipe: "Plateforme",
    notes:
      "Exemple vivant de l’importance de la politique « pas de mise en prod le vendredi soir ». Participe désormais activement à la sensibilisation sur les bonnes pratiques de déploiement."
  },
  {
    id: 173,
    prenom: "Yassine",
    nom: "Benkacem",
    poste: "Analyste sécurité",
    equipe: "SecOps",
    notes:
      "Anime des ateliers ludiques sur la sécurité des mots de passe. A déjà transformé trois « azerty1234 » en phrases de passe robustes sans braquer personne."
  },
  {
    id: 181,
    prenom: "Zoé",
    nom: "Leroy",
    poste: "Chargée de communication",
    equipe: "Com externe",
    notes:
      "Sait traduire un incident critique en message clair et non anxiogène. Participe au comité éditorial sur l’éthique d’Origami et la manière de parler de l’IA au grand public."
  },
  {
    id: 194,
    prenom: "Martin",
    nom: "Schmitt",
    poste: "Tech lead frontend",
    equipe: "Origami UI",
    notes:
      "Possède 47 thèmes de dark mode différents. Milite pour que les interfaces d’Origami restent accessibles (contraste, lecteurs d’écran, tailles de police) et pas seulement « jolies pour les devs »."
  },
  {
    id: 221,
    prenom: "Hugo",
    nom: "Bernard",
    poste: "Stagiaire QA",
    equipe: "Qualité",
    notes:
      "Trouve des bugs sans comprendre comment. L’équipe lui a fabriqué un guide de bonnes pratiques pour canaliser ce talent tout en lui donnant des outils structurés de test."
  },
  {
    id: 248,
    prenom: "Thomas",
    nom: "Dubois",
    poste: "Admin systèmes",
    equipe: "Infra",
    notes:
      "Prend très au sérieux la résilience des systèmes. A mis en place une procédure pour documenter chaque incident sans chercher de coupable, uniquement des pistes d’amélioration."
  },
  {
    id: 272,
    prenom: "Olivier",
    nom: "Garnier",
    poste: "Directeur technique",
    equipe: "Direction",
    notes:
      "Phrase préférée : « On fera ça dans une V2 ». Récemment engagé sur un plan pluriannuel de réduction de la consommation énergétique de l’infra."
  },
  {
    id: 286,
    prenom: "Nadia",
    nom: "El Mansouri",
    poste: "Data engineer",
    equipe: "Origami Data",
    notes:
      "Parle de ses pipelines comme d’animaux domestiques. Participe au chantier de gouvernance des données pour s’assurer que les flux d’Origami restent conformes aux règles internes et au RGPD."
  },
  {
    id: 297,
    prenom: "Lucas",
    nom: "Fournier",
    poste: "Chef de projet",
    equipe: "Delivery",
    notes:
      "Travaille avec des post-its de toutes les couleurs, utilisés aussi pour suivre les risques de charge mentale. Fait systématiquement un tour de table « météo personnelle » en début de gros projet."
  },
  {
    id: 312,
    prenom: "Amira",
    nom: "Belkacem",
    poste: "Juriste",
    equipe: "Legal",
    notes:
      "A co-rédigé les lignes directrices internes sur l’usage d’Origami et des IA génératives. Peut dire « on va peut-être éviter d’écrire ça dans un mail » avec une douceur glaçante."
  },
  {
    id: 328,
    prenom: "Victor",
    nom: "Laurent",
    poste: "Ingénieur réseau",
    equipe: "Infra",
    notes:
      "Met des noms de séries aux VLAN, mais tient une documentation rigoureuse et partagée pour que tout le monde s’y retrouve. Sensibilisé aux impacts environnementaux du réseau."
  },
  {
    id: 341,
    prenom: "Sofia",
    nom: "Martins",
    poste: "Scrum master",
    equipe: "Origami Core",
    notes:
      "Ancre systématiquement les rétrospectives sur la sécurité psychologique : on parle des processus, pas des personnes. Rappelle souvent que les erreurs sont des signaux, pas des fautes."
  },
  // ⭐ ENTRÉE CRITIQUE POUR LE JEU
  {
    id: 359,
    prenom: "Marie",
    nom: "Dupont",
    poste: "Analyste linguistique",
    equipe: "Origami NLP",
    notes:
      "Travaille souvent tard, bureau recouvert de post-its multicolores. Parle très (trop) régulièrement de son chat. A demandé un thème Origami « spécial chat ». Mentionné en entretien annuel : ne plus utiliser le nom de son chat comme mot de passe, même par réflexe."
  },
  {
    id: 374,
    prenom: "Antoine",
    nom: "Leclerc",
    poste: "Responsable qualité",
    equipe: "Qualité",
    notes:
      "Tient un tableau de « bugs historiques » utilisé comme support pédagogique pour parler de culture d’erreur plutôt que de blâme. A proposé une charte de revue de code bienveillante."
  },
  {
    id: 389,
    prenom: "Camille",
    nom: "Henry",
    poste: "Chef de produit",
    equipe: "PaperFold Watch",
    notes:
      "Officiellement chargée de la veille concurrentielle. Dit souvent « c’est sûrement un hasard » en regardant les annonces de PaperFold, tout en rappelant les règles d’éthique et de non-divulgation."
  }
];